module.exports = __webpack_public_path__ + "img/money-from-bracket.b5003f0a.svg";